import styles from './InitialPageL2.module.css'
import LeafletMap from './maps/LeafletMap'
import PieGraph from '../../../general/PieGraph'
import Api from '../../../../services/Api'
import Functions from '../../../../services/Functions'
import React, { useEffect, useState } from "react";

function InitialPageL2({ distrito, onDistrictMapChange, setImovelImage}) {
  const [imoveisDistritoData, setImoveisDistritoData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Api.getImoveisPorDistrito().then((value) => {
      if (value && Array.isArray(value.labels) && Array.isArray(value.data)) {
        const data = Functions.buildPieGraphParams(value.labels, value.data);
        setImoveisDistritoData(data);
      } else {
        console.warn("Dados inválidos recebidos da API:", value);
      }
      setLoading(false); // termina o loading mesmo se a API falhar
    });
  }, []);

  return (
    <div className={styles.initialPageL2}>
      <LeafletMap
        distrito={distrito}
        onDistrictMapChange={onDistrictMapChange}
      />

      <div className={styles.pieGraph}>
        {loading && <p>Carregando gráfico...</p>}

        {!loading && imoveisDistritoData && (
          <PieGraph
            text="IMÓVEIS CADASTRADOS POR DISTRITO"
            data={imoveisDistritoData}
            onImageReady={setImovelImage}
          />
        )}

        {!loading && !imoveisDistritoData && (
          <p style={{ color: 'red' }}>Erro ao carregar dados do gráfico.</p>
        )}
      </div>
    </div>
  );
}

export default InitialPageL2;
